// extracted by mini-css-extract-plugin
module.exports = {"XS":"360px","SM":"640px","MD":"1024px","LG":"1280px","XL":"1440px","xxl":"1920px","Root":"App_Root__3OGYg","Loader":"App_Loader__1KIEC"};